export default function uuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0; const v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

const nonIncrementCharIndices = new Set([8, 13, 14, 18, 19, 23])

/**
 * Add `increment` to a UUID, treating its hex digits as one number.
 * Used to deterministically generate several unique UUIDs from one UUID, so each
 * increment must give a different UUID (e.g. one per ticket on an experience cart item).
 * The hyphens and the version/variant chars are skipped, so the result is still a v4 UUID.
 */
export function incrementUuidV4(uuid: string, increment: number = 1) {
  if (uuid.length !== 36) { throw new Error('Invalid UUID') }
  const chars = uuid.split('')

  let carry = increment
  for (let i = 35; i >= 0 && carry > 0; i--) {
    if (nonIncrementCharIndices.has(i)) { continue }

    const sum = parseInt(chars[i], 16) + carry
    chars[i] = (sum % 16).toString(16)
    carry = Math.floor(sum / 16)
  }

  return chars.join('')
}

/**
 * Check if a string is a valid UUID v4.
 * @param uuid - The string to check.
 * @returns True if the string is a valid UUID v4, false otherwise.
 */
export function isUuidV4(uuid: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(uuid)
}
